export default {
    'diagram3b3-4': {
        'diagram-task': 'Complete the pyramid and identify whether the argument on the Key Line level is Inductive or Deductive',
        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
        'element_1_1': 'The ones that do hit it big drive innovation for society as a whole',
        'element_1_2': 'They can’t tell in advance what companies will succeed',
        'element_1_3': 'Our economy relies on the unrealistic expectations of our entrepreneurs',
        'element_1_4': 'They fund lots of companies, in the hope that a few will hit it big',
        'hint-title': 'Hint',
        'resubmit-title': 'Resubmit'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b3/diagram4/i18n/en.js